import React, { lazy } from 'react';
import { createRoot } from 'react-dom/client';
import type { IConsentItemProps } from './consent-item';

const ConsentItem = lazy(async () => import('./consent-item'));

const el = '.fa-component--consent-item';
const DOM = document.querySelectorAll(el);

const render = function () {
    if (DOM) {
        DOM.forEach((component) => {
            const props = JSON.parse(component.getAttribute('data-props')!) as IConsentItemProps;

            createRoot(component).render(<ConsentItem {...props} />);
        });
    }
};

export default {
    render,
};
